var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',{style:(_vm.style)},[(_vm.model.preText && _vm.value)?_c('span',[_vm._v(" "+_vm._s(_vm.model.preText)+" ")]):_vm._e(),_vm._v(" "+_vm._s(_vm.text || _vm.value)+" ")])
}
var staticRenderFns = []

export { render, staticRenderFns }